module.exports = __webpack_public_path__ + "img/2.e7f934d2.png";